import { defineComponent as _defineComponent } from 'vue'
import { DataInstance } from '@busy-human/gearbox';
import { InviteLinks, Userspaces } from '@busy-human/opt-library';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import Loader from './loader.vue';

type Props = {
    offerLink?: string
    isPreview?: boolean
    isLoading?: boolean
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'opt-offer',
  props: {
    offerLink: null,
    isPreview: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    offerLink?: string
    isPreview?: boolean
    isLoading?: boolean
}





const error = ref()

const offer = ref<DataInstance<InviteLinks.Model> | null>(null);
const person = ref<DataInstance<Userspaces.Model> | null>(null);

const offerType = ref("")

watch(() => props.offerLink, async offerLink => {
    if(offerLink) {
        offer.value = await InviteLinks.Collection.fetchInviteForLink(offerLink as string);
        if(!offer.value ) {
            error.value = "Invite Doesn't Exist"
            return;
        }
        if(!offer.value.active && !props.isPreview){
            error.value = "Invite Not Active"
            return;
        }
        const personID = offer.value.payer || offer.value.collector;

        offerType.value = offer.value.payer ? "payer" : "collector"
        person.value = (await Userspaces.Collection.fetchDoc(personID!)).data();
    }
}, {immediate: true})

const router = useRouter();

const scheduleMeeting = () => {
    router.push({name: 'meeting-request', params: { 'offerLink': props.offerLink }})
}

const checkNoteLength = (length: number)=>{
    if(length < 125){
        return true
    }
    return false
}

const __returned__ = { props, emit, error, offer, person, offerType, router, scheduleMeeting, checkNoteLength, DataInstance, InviteLinks, Userspaces, ref, watch, useRouter, Loader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})